import { useCallback } from 'react'
import { CircularProgress } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { Button } from '@components/v2/button'
import {
  TaxonomyTranslation,
  TaxonomyTranslationPaginationParams,
} from '@taxonomy-translation/types'
import GuyStanding from 'images/guy-standing-circle.svg'
import NoData from 'images/taxonomy-empty-state.svg'
import { ROUTES } from 'routes'
import { EmptyList } from './empty-list'
import { TranslationListItem } from './translation-list-item'
import { t } from '@lingui/core/macro'

interface TaxonomyTranslationListProps {
  params: TaxonomyTranslationPaginationParams
  data: TaxonomyTranslation[]
  isLoading: boolean
}

export const List = ({ data, params, isLoading }: TaxonomyTranslationListProps) => {
  const { search } = params
  const history = useHistory()

  const handleNewTaxonomyTranslation = useCallback(() => {
    history.push(ROUTES.TAXONOMY_TRANSLATION_UPLOAD)
  }, [history])

  return (
    <div className="flex flex-col grow">
      {isLoading ? (
        <div className="flex flex-1 justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {data.length > 0 ? (
            data.map(translation => (
              <TranslationListItem item={translation} key={translation.uuid} />
            ))
          ) : search ? (
            <EmptyList
              title={t`No search results for “${search}”`}
              subtitle={t`Try searching for another translation or create a new one.`}
              image={GuyStanding}
              extra={
                <Button
                  onClick={handleNewTaxonomyTranslation}
                >{t`New taxonomy translation`}</Button>
              }
            />
          ) : (
            <EmptyList
              image={NoData}
              title={t`Translate different taxonomies to harmonize your campaigns across clients`}
              subtitle={t`Create more aligned campaign data for your analytics team and start building your campaign templates in minutes, not hours.`}
              extra={
                <Button
                  onClick={handleNewTaxonomyTranslation}
                >{t`New taxonomy translation`}</Button>
              }
            />
          )}
        </div>
      )}
    </div>
  )
}
